<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h1 class="page-title">
                        {{ page_title }}
                        <small><a href="#" @click.prevent="view_city = !view_city && view !== 'map'">Alterar cidade</a></small>
                        <span v-if="show_current_page">
                            <h5 class="m-0">Página {{ pagination.current_page }} <button class="btn btn-link" @click="resetPage()">Página 1</button></h5>
                        </span>
                    </h1>
                    <google-signin-button v-if="view == 'list'" button-id="search-google-signin" :show-button="false" :use-prompt="true"></google-signin-button>
                </div>
            </div>
        </div>
		<div class="row">
            <div class="col-xs-12 m-b-30" v-if="show_city_search">
				<location-search :ptype="search_type" :plocation="$store.getters.getCityName" :sanitize="true" inline-template>
					<div class="city_search">
                        <p class="h5 m-b-10 text-muted">Digite o nome da cidade onde você procura um lugar para alugar:</p>
						<div class="form-inline" v-bind:class="{'has-error': locationError}" id="form_search">
							<search-autocomplete
								name="location_input"
								ref="location"
								id="location"
								classname="form-control"
								placeholder="Digite o nome da cidade que você está procurando"
								:value="city_name"
								:params="{ types: ['city'] }"
								v-on:placechanged="getLocation"
                                v-on:preselect="preSelectItem">
							</search-autocomplete>
							<button id="city-autocomplete-btn" data-style="slide-left" @click="searchLocation()" ref="sbm_btn" class="btn btn-custom btn-bordered waves-effect waves-light ladda-button">
								<span class="ladda-label"><i class="fas fa-search m-r-5"></i> Procurar</span></button>
						</div>
					</div>
				</location-search>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            view_city: false,
            isDirectPageAccess: false
        }
    },
    computed: {
        view() {
            return this.$store.getters.getView;
        },
        city_name() {
            return this.$store.getters.getCityName;
        },
        page_title() {
            return this.$store.state.page_title;
        },
        search_type() {
            return this.$store.getters.getSelectedTypeSlug;
        },
        location() {
            return this.$store.getters.getCitySlug;
        },
        show_city_search() {
            return this.location == '' || this.location == null || this.view_city == true;
        },
        show_current_page() {
            return this.pagination.current_page > 1 && this.isDirectPageAccess && this.view !== 'map';
        },
        pagination() {
            return this.$store.getters.getPagination;
        }
    },
    methods: {
        changeView() {
            let url = '/busca';
            if (this.view === 'list') {
                url = '/busca-mapa';
            }

            let type = this.$store.state.search_type;
            if (type != '' && typeof type != 'undefined')
                url = url + '/' + type;
            if (this.location != '' && typeof this.location != 'undefined')
                url = url + '/' + this.location;

            location.href = url;
        },
        resetPage() {
            this.$store.commit('setPage', 1);
            this.$store.dispatch('replaceUrl');
            location.reload();
        }
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageParam = urlParams.get('page');
        if (pageParam && parseInt(pageParam) > 1) {
            this.isDirectPageAccess = true;
        }
    }
}
</script>

<style lang="scss">
#form_search {
	display: flex;

	button {
		min-width: 110px;
		flex-grow: 0;
	}

	input[type="text"] {
		flex-grow: 1;
	}
}

.city_search {
    width: 700px;
    max-width: 100%;
    float: none;
    margin: 0 auto;
}

.page-title {
    font-size: 26px !important;

    a {
        font-size: 13px !important;
    }
}
.ovf_row {
    a {
        font-weight: bold;
        font-size: 13px;
        top: 7px;
        position: relative;
    }
}
</style>
